//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.1.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum TrainingELearningPhase {
    Preparation = 0,
    FollowUp = 1,
}

export interface TrainingModuleReleaseVm {
    id: number;
    moduleGuid: string | null;
    moduleName: string | null;
    isMissing: boolean;
    afterSessionOrder: number | null;
}

export interface TrainingEventExBundleVm {
    id: number;
    trainingEventId: number;
    exBundleId: number;
    exBundleName: string | null;
    isSequential: boolean;
    phase: TrainingELearningPhase;
    order: number;
    isCompletionRelevant: boolean;
    assignmentOffsetDays: number | null;
    deadlineOffsetDays: number | null;
    absoluteAssignmentDate: Date | null;
    absoluteDeadline: Date | null;
    moduleReleases: TrainingModuleReleaseVm[] | null;
}